/* eslint-disable no-console */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable no-underscore-dangle */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import {
  Typography,
  Card,
  Grid,
  CardActionArea,
  Snackbar,
} from '@material-ui/core';
import { Circle } from 'rc-progress';

import Alert from '@material-ui/lab/Alert';
import { Check, Close } from '@material-ui/icons';
import moduleServices from '../../../redux/services/moduleServices';
import config from '../../../config';

const useStyles = makeStyles({
  root: {
    width: '100%',
    height: '100%',
  },
  actionArea: {
    width: '100%',
    height: '100%',
  },
  title: {
    padding: '1em',
    paddingTop: '0px',
    textAlign: 'center',
    fontSize: '20px',
  },
  subtitle: {
    fontSize: '17px',
    fontStyle: 'italic',
    color: '#4F4F4F',
  },
  center: {
    margin: 'auto',
  },
  circleContainer: {
    padding: '15px',
  },
  fullWidth: {
    width: '100%',
    maxWidth: '100%',
  },
  percentageText: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minWidth: '100%',
  },
});

const TotalProgressWidget = ({
  data, currentGroup, authData, darkMode,
}) => {
  const classes = useStyles();
  const [goal, setGoal] = useState(100);
  const [isCompleted, setIsCompleted] = useState(false);
  const [totalProgress, setTotalProgress] = useState(0);
  const [errorSnackBar, setErrorSnackBar] = useState(null);
  const { innerWidth: width } = window;
  const isSmallScreen = width < 450;
  const colorPrimary = darkMode ? config.darkColor : config.primaryColor;

  useEffect(() => {
    setIsCompleted(false);
    if (data[currentGroup] && authData._id) {
      moduleServices.globalResultsTest(authData._id, authData.loginLRS, data[currentGroup]._id)
        .then((res) => {
          let total = 0;
          let quizPercent = 0;
          res[0].forEach((module) => {
            module.units.forEach((unit) => {
              if (unit.unit.isFinalQuiz === true || unit.unit.isRise === true) {
                total += 1;
                if (unit.result.success || unit.result.completion) {
                  if (unit.result && unit.result.score) {
                    quizPercent += (
                      ((
                        unit.result.score.scaled || unit.result.score.scaled === 0)
                        ? unit.result.score.scaled / 1
                        : unit.result.score.raw / unit.result.score.max
                      )
                    ) * 100;
                  } else if (unit.result.completion && unit.result.success) {
                    quizPercent += 100;
                  }
                }
              }
            });
          });
          quizPercent /= total;
          setTotalProgress(Math.floor(quizPercent));
          setGoal(res[1].elearningTarget);
        })
        .catch(() => {
          setErrorSnackBar({ code: 2701, message: 'Missing total progress data.', severity: 'error' });
        });
    }
  }, [currentGroup, totalProgress]);

  return (
    <Card direction="row" className={classes.root}>
      <Snackbar role="alert" open={errorSnackBar !== null} onClose={() => { setErrorSnackBar(null); }} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
        <Alert severity={errorSnackBar !== null ? errorSnackBar.severity : 'info'} variant="filled" onClose={() => { setErrorSnackBar(null); }}>
          {`Error ${errorSnackBar?.code}: ${errorSnackBar?.message}`}
        </Alert>
      </Snackbar>
      <CardActionArea
        component={Link}
        to={{
          pathname: '/elearning/results',
        }}
        className={classes.actionArea}
      >
        <Grid className={classes.actionArea} container direction="row" alignItems="center" alignContent="center">
          <Grid container item xs={6} md={6} direction="column" alignItems="center" alignContent="center">
            <Grid className={classes.fullWidth} item xs={4} md={4}>
              <Typography component="h3" variant="h5" className={classes.title}>
                Success Rate
              </Typography>
            </Grid>
            <Grid item xs={4} md={4} className={classes.percentageText}>
              <Typography component="h3" variant="h4" className={`${classes.center} ${classes.percentage}`}>
                {`${Math.trunc(totalProgress)} %`}
              </Typography>
            </Grid>
            <Grid
              className={classes.fullWidth}
              item
              xs={4}
              md={4}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '1em',
                gap: '10px',
              }}
            >
              <Typography
                component="h4"
                variant="h4"
                className={classes.subtitle}
                style={{
                  color: darkMode ? '#b9b9b9e9' : '#4F4F4F',
                }}
              >
                {`Goal : ${goal}%`}
              </Typography>
              {totalProgress >= goal
                ? (
                  <Check
                    style={{
                      padding: '0px',
                      margin: '0px',
                      color: '#62D562',
                    }}
                  />
                )
                : (
                  <Close
                    color="secondary"
                    style={{
                      padding: '0px',
                      margin: '0px',
                    }}
                  />
                )}
            </Grid>
          </Grid>
          <Grid className={classes.circleContainer} item xs={6} md={6}>
            { isSmallScreen
              ? (
                <Circle
                  percent={totalProgress}
                  strokeWidth="9"
                  trailWidth="9"
                  strokeColor={isCompleted ? '#66DD66' : colorPrimary}
                  style={{ width: '75%', marginLeft: '11%' }}
                  aria-label={`Progression totale : ${Math.trunc(totalProgress)}%, Objectif : ${goal}%`}
                />
              )
              : (
                <Circle
                  percent={totalProgress}
                  strokeWidth="9"
                  trailWidth="9"
                  strokeColor={isCompleted ? '#66DD66' : colorPrimary}
                  style={{ width: '9rem' }}
                />
              )}
          </Grid>
        </Grid>
      </CardActionArea>
    </Card>
  );
};

TotalProgressWidget.propTypes = {
  currentGroup: PropTypes.number.isRequired,
  data: PropTypes.array.isRequired,
  authData: PropTypes.object.isRequired,
  darkMode: PropTypes.bool.isRequired,
};

function mapState(state) {
  const { data } = state.group;
  const { darkMode } = state.ui;
  const { authData } = state.auth;
  const { currentGroup } = state.ui;
  return {
    data, authData, currentGroup, darkMode,
  };
}

export default connect(mapState, {})(TotalProgressWidget);
